import '/src/components/order-status/order-status.js';
  import { extractOrderIdFromUrl, setOrderPageTitle } from '/src/helper.js';

  const orderId = extractOrderIdFromUrl();
  const orderStatusElement = document.querySelector('order-status');

  if (orderId) setOrderPageTitle(orderId);

  if (orderStatusElement && orderId) {
    orderStatusElement.orderCode = orderId;
  }
import '/src/components/local-order-storage/local-order-storage.js';
  import '/src/components/discount-badge/discount-badge.js';